<template>
  <v-layout row>
    <div style="width:100%;">
      <v-flex xs12>
        <v-card color="primary" ref="footerGridMeasureContainer">
          <v-container fluid grid-list-sm>
            <v-layout row wrap class="">
              <v-flex xs3 class="pa-2">
                <product-data-input
                  defaultContractProductIndex="0"
                  @showHintDialog="showHintDialog"
                ></product-data-input>
                <!--
                <v-avatard
                  v-if="this.$store.state.work.forxchange.offerRequest.contract.products.length < 1"
                  class="pa-0 elevation-0 euro-one productAvatar noProductToShow"
                  @click="hintDialog=true"
                >
                  <img :src="placeholderWithPriceSource" alt="" />
                </v-avatar>
                -->
              </v-flex>
              <v-flex xs3 class="pa-2">
                <product-data-input
                  defaultContractProductIndex="1"
                  @showHintDialog="showHintDialog"
                ></product-data-input>
              </v-flex>
              <v-flex xs3 class="pa-2">
                <product-data-input
                  defaultContractProductIndex="2"
                  @showHintDialog="showHintDialog"
                ></product-data-input>
              </v-flex>
              <v-flex xs3 class="pa-2">
                <product-data-input
                  defaultContractProductIndex="3"
                  @showHintDialog="showHintDialog"
                ></product-data-input>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="">
              <dialog-contract-request></dialog-contract-request>
            </v-layout>
          </v-container>
          <v-dialog v-model="hintDialog" max-width="350">
            <v-card>
              <v-toolbar dark color="primary lighten-1">
                <v-toolbar-title>Hinweis</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                Bitte eine der obigen Kategorien wählen!
              </v-card-text>
              <v-card-actions>
                <v-btn block class="primary" @click="hintDialog = false">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import ProductDataInput from "./DialogProductDataInput";
import { mapGetters } from "vuex";
import DialogContractRequest from "./DialogContractRequest";

export default {
  name: "HomeFooterGrid",
  data() {
    return {
      footerGridWidth: 0,
      showTestExportData: false,
      hintDialog: false
    };
  },
  components: {DialogContractRequest, ProductDataInput },
  computed: {
    placeholderWithPriceSource(){
      if(this.$store.state.work.supposedlyYoungerThan32) {
        return "images/icons/svg/weiss/leer_2Euro.svg";
      }
      return "images/icons/svg/weiss/leer_4Euro.svg";
    },
    iconBorderClass() {
      // zunächst statisch
      return "redBorder";
    },
    contactRequestButtonStyle() {
      let x = this.$store.state.viewportWidth / 2 - 40 + "px";
      let y = "-52px";
      return (
        "transform: translate(" +
        x +
        "," +
        y +
        "); background-color: #3358B9; z-index: 1;"
      );
    },
    ...mapGetters("work", {
      selectedProductsLength: "getSelectedProductsLength"
    })
  },
  methods: {
    showHintDialog(){
      this.hintDialog = true;
    }
  }
};
</script>

<style scoped>
/* Abschluss-Button */
div.contractRequestLayout {
  height: 0 !important;
}
button.contractRequest.theme--dark {
  display: flow-root;
  border: 2px solid white;
  color: white;
}
button.contractRequest.theme--dark i.v-icon {
  font-size: 40px;
  transform: translate(-2px, -2px);
}

/* Avatare */

div.v-avatar.noProductToShow img:hover {
  background-color: transparent;
}
div.v-avatar:not(.noProductToShow) img:hover {
  background-color: #002ea7;
}
div.v-avatar.productAvatar {
  background-color: #6682ca;
  border: 3px solid #da291c;
  overflow: hidden;
  width: 72px !important;
  height: 72px !important;
}

div.v-avatar.noProductToShow::before {
  position: absolute;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  text-align: center;
  font-size: 2em;
  padding-top: 18%;
  filter: grayscale(1);
  opacity: 0.5;
}

div.euro-one::before {
  content: "";
}
div.euro-two::before {
  content: "";
}
div.euro-three::before {
  content: "";
}
div.euro-four::before {
  content: "";
}

div.v-avatar button {
  display: none;
}
div.v-avatar.withProductAllData img {
  display: none;
}
div.v-avatar.withProductAllData button {
  display: block;
}
div.v-avatar.noProductToShow {
  background-color: #ccd5ed;
  border: 3.5px solid white;
}
div.v-avatar.noProductToShow-info {
  text-align: center;
  color: #002ea7;
  background-color: #ccd5ed;
  border: 3px solid white;
}
div.v-avatar.noProductToShow-info p.info::after {
  content: "Gegenstand oben auswählen";
}
div.v-avatar.withProductNoData {
  background-color: #6682ca;
  border: 3px solid #da291c;
}
div.v-avatar.withProductNoData-info {
  background-color: #6682ca;
  border: 3px solid #da291c;
  color: white;
}
div.v-avatar.withProductNoData-info p.info::after {
  content: "Angaben zum Gegenstand machen";
}
div.v-avatar.withProductSomeData {
  background-color: #6682ca;
  border: 3px dashed #00a520;
}
div.v-avatar.withProductSomeData-info {
  text-align: center;
  background-color: #6682ca;
  border: 3px dashed #00a520;
}
div.v-avatar.withProductSomeData-info p.info::after {
  content: "Angaben vervollständigen";
}
div.v-avatar.withProductAllData {
  background-color: #6682ca;
  border: 3px solid #00a520;
}
div.v-avatar.withProductAllData-info {
  background-color: #6682ca;
  border: 3px solid #00a520;
}
div.v-avatar.withProductAllData-info p.info::after {
  content: "Perfekt!";
  text-transform: uppercase;
}
</style>
